import { createSelector } from 'reselect'

const onboardingActivitySelector = state => state.onboardingActivity

export default createSelector(
	[ onboardingActivitySelector ],
	onboardingActivityData => ({
		lessonId: onboardingActivityData.lessonId,
		isDeleted: onboardingActivityData.isDeleted,
		customSlideId: onboardingActivityData.customSlideId,
		parentCustomSlideId: onboardingActivityData.parentCustomSlideId,
		jwt: onboardingActivityData.jwt,
	})
)
